if ( typeof LeafletMap !== 'function' ) {

  class LeafletMap extends HTMLElement {

    constructor(){
      super();

      let initTimer,
          initObserver;

      initTimer = setTimeout(()=>{
        this.init();
        initObserver.unobserve(this);
      }, 10000);

      initObserver = new IntersectionObserver((entries, observer) => {
        if ( ! entries[0].isIntersecting ) {
          return;
        } else {
          this.init();
          clearInterval(initTimer);
          observer.unobserve(this);
        }
      });
      initObserver.observe(this);
    }

    init(){
      if ( window.L ) {
        this.createMap();
      } else {
        if ( window.loadingLeafletScript ) {
          this.ti = setInterval(()=>{
            if ( window.L ) {
              clearInterval(this.ti);
              this.createMap();
            }
          }, 100);
        } else {
          window.loadingLeafletScript = true;

          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
          document.head.appendChild(link);

          const script = document.createElement('script');
          script.defer = true;
          script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
          script.onload = ()=>{
            this.createMap();
          };
          document.body.appendChild(script);
        }
      }
    }

    createMap(){

      const mapEl = this.querySelector('[data-js-map-object]');
      const mapMarkers = this.querySelectorAll('[data-js-map-addresses] li');

      const map = L.map(mapEl.id, {
        minZoom: 2,
        zoom: parseInt(this.dataset.zoom),
        scrollWheelZoom: false,
        zoomControl: true,
        dragging: true
      });

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(map);

      const bounds = L.latLngBounds();

      const pinSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="30" height="40" viewBox="0 0 30 40"><path d="M15 0C6.7 0 0 6.7 0 15c0 11.25 15 25 15 25s15-13.75 15-25C30 6.7 23.3 0 15 0zm0 20a5 5 0 1 1 0-10 5 5 0 0 1 0 10z" fill="#F05A22"/></svg>`;
      const pinIconUrl = 'data:image/svg+xml;base64,' + btoa(pinSvg);

      this.markers = {};
      mapMarkers.forEach((elm)=>{

        const latLng = L.latLng(parseFloat(elm.dataset.latitude), parseFloat(elm.dataset.longitude));

        const icon = L.icon({
          iconUrl: pinIconUrl,
          iconSize: [30, 40],
          iconAnchor: [15, 40]
        });

        const marker = L.marker(latLng, { icon: icon }).addTo(map);

        bounds.extend(latLng);

        marker.on('click', ()=>{

          this.dispatchEvent(new CustomEvent("marker", {
            detail: {
              store: elm.dataset.id
            }
          }));

          map.panTo(latLng);

          // Remove scaled class from all markers
          this.querySelectorAll('.leaflet-marker-icon').forEach(el=>{
            el.classList.remove('scaled-store-icon');
          });

          // Add scaled class to clicked marker
          const markerEl = marker.getElement();
          if ( markerEl ) {
            markerEl.classList.add('scaled-store-icon');
          }

          // Open the corresponding store accordion tab
          const storeSelector = document.getElementById('StoreSelector');
          if ( storeSelector ) {
            const item = storeSelector.querySelector(`.store-selector-item[data-handle="${elm.dataset.id}"]`);
            if ( item && ! item.classList.contains('store-selector-item--active') ) {
              const tab = item.querySelector('.js-accordion-tab-toggle') || item.querySelector('.js-accordion-tab');
              if ( tab ) tab.click();
            }
          }

        });

        this.markers[elm.dataset.id] = marker;
      });

      map.fitBounds(bounds);

      map.once('idle', ()=>{
        map.setZoom(parseInt(this.dataset.zoom));
      });

      // Google Maps shim so component-store-selector.js works unchanged
      if ( ! window.google ) {
        window.google = { maps: { event: {} } };
      }
      if ( ! window.google.maps ) {
        window.google.maps = { event: {} };
      }
      if ( ! window.google.maps.event ) {
        window.google.maps.event = {};
      }
      window.google.maps.event.trigger = function(marker, eventName) {
        if ( marker && typeof marker.fire === 'function' ) {
          marker.fire(eventName);
        }
      };

      this.dispatchEvent(new CustomEvent("ready"));

    }

  }

  if ( typeof customElements.get('leaflet-map') == 'undefined' ) {
    customElements.define('leaflet-map', LeafletMap);
  }

}
